import React from 'react';
import ReactApexChart from 'react-apexcharts';
import './dashboard.scss';
import getChartColorsArray from '../../components/Common/ChartsDynamicColor';

// Define props interface
interface ApexRadialProps {
  dataColors: string;
}

// Define the chart options type (based on ApexCharts options structure)
interface ChartOptions {
  plotOptions: {
    radialBar: {
      startAngle: number;
      endAngle: number;
      dataLabels: {
        name: {
          fontSize: string;
          color?: string;
          offsetY: number;
        };
        value: {
          offsetY: number;
          fontSize: string;
          color?: string;
          formatter: (val: number) => string;
        };
      };
    };
  };
  colors: string[];
  fill: {
    type: string;
    gradient: {
      shade: string;
      shadeIntensity: number;
      inverseColors: boolean;
      opacityFrom: number;
      opacityTo: number;
      stops: number[];
    };
  };
  stroke: {
    dashArray: number;
  };
  labels: string[];
}

const ApexRadial: React.FC<ApexRadialProps> = ({ dataColors }) => {
  const apexRadialChartColors: string[] = getChartColorsArray(dataColors);
  const series: number[] = [67];

  const options: ChartOptions = {
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: '13px',
            color: undefined,
            offsetY: 60,
          },
          value: {
            offsetY: 22,
            fontSize: '16px',
            color: undefined,
            formatter: (val: number) => `${val}%`,
          },
        },
      },
    },
    colors: apexRadialChartColors,
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        shadeIntensity: 0.15,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91],
      },
    },
    stroke: {
      dashArray: 4,
    },
    labels: ['Series A'],
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="radialBar"
      height={200}
      className="apex-charts"
    />
  );
};

export default ApexRadial;
